import axios from 'axios';
import {setToken, setAccessToken} from '../utils'
import Config from '../config';

export default class Session {
  axiosOrigin = axios.create({
    baseURL: Config.AUTH_URL
  });

  async login() {
    const tokenData = await this.getAccessToken();

    setToken(tokenData.id_token);
    setAccessToken(tokenData.token)
    this.refreshToken();
  }

  getAccessToken() {
    return new Promise((resolve, reject) => {
      window.Session.getToken(resolve, reject)
    })
  }

  redirectWKLogin() {
    const _l = window.location;
    const next = _l.pathname + _l.search;
    const url = window.location.origin + next;
    window.location.href = `${Config.AUTH_URL}/oauth2/authorize?client_id=${
      Config.CLIENT_ID
    }&response_type=cookie&redirect_uri=${encodeURIComponent(url)}`;
  }

  refreshToken() {
    this.refreshTimer && clearTimeout(this.refreshTimer);
    this.refreshTimer = setTimeout(() => {
      this.login();
    }, 3600 * 1e3);
  }
}



// WEBPACK FOOTER //
// ./src/services/Session.js